import type { IconSvgObject } from './types';

const Notion01Icon: IconSvgObject = [
  ["path", { d: "M19.5 2.5C20.6046 2.5 21.5 3.39543 21.5 4.5V19.5C21.5 20.6046 20.6046 21.5 19.5 21.5H4.5C3.39543 21.5 2.5 20.6046 2.5 19.5V4.5C2.5 3.39543 3.39543 2.5 4.5 2.5H19.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15.5 13.3779L10.5556 7L8.4837 7.0002M15.5 13.3779V16.9998L13.5 17L8.4837 10.0302M15.5 13.3779V7M8.4837 10.0302V7.0002M8.4837 10.0302V17M7 7.0002H8.4837M8.4837 17H7.02672M8.4837 17H10.0075M15.5 7L17 7.0002M15.5 7L14.0339 7.0002", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Notion01Icon;
